import { t } from '@/i18n'

export interface ModelType {
  name: string
  taskInfoExpanded: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }
      | {
          device_ip: string
          device_brand: string
        }
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
    deepType?:
      | {
          id: string
          name: string
        }
      | { device_ip: string; device_brand: string }
  }[]
  taskInfo: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }[]
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
  }[]
}

export const displayModel = {
  name: 'WS',
  taskInfoExpanded: [
    {
      key: t('模式名称'),
      value: 'attackSource',
      type: 'string',
    },
    {
      key: t('资产名称'),
      value: 'site_name',
      type: 'string',
    },
    {
      key: t('安全域'),
      value: 'area_name',
      type: 'string',
    },
    {
      key: t('任务分组'),
      value: 'group_name',
      type: 'string',
    },
    {
      key: t('执行类型'),
      value: [
        {
          value: 'scheduler_type',
          type: 'string',
          default: t('立即'),
        },
        {
          value: 'task_time_list',
          type: 'array',
          deepType: {
            item: 'string',
          },
        },
      ],
    },
    {
      key: t('执行速率'),
      value: 'reduce_speed',
      type: 'number',
    },
    {
      key: t('任务优先级'),
      value: 'priority',
      type: 'number|string',
    },
    {
      key: t('代理池'),
      value: 'pool_name',
      type: 'string',
    },
    {
      key: t('动态编码'),
      value: 'enctypeTypes',
      type: 'array',
      deepType: {
        item: 'string',
      },
    },
    {
      key: t('创建时间'),
      value: 'createTime',
      type: 'string',
    },
    {
      key: t('任务模板'),
      value: 'template_list',
      type: 'array',
      deepType: {
        item: 'string',
      },
    },
    {
      key: t('安全设备'),
      value: 'device_list',
      type: 'array',
      deepType: {
        device_brand: 'string',
        device_ip: 'string',
      },
    },
  ],
  taskInfo: [
    {
      key: t('资产名称'),
      value: 'site_name',
      type: 'string',
    },
    {
      key: t('安全域'),
      value: 'area_name',
      type: 'string',
    },
    {
      key: t('进度信息'),
      value: [
        {
          value: 'status',
          type: 'number',
        },
        {
          value: 'progress',
          type: 'number',
        },
        {
          value: 'send_success',
          type: 'number',
        },
        {
          value: 'send_failed',
          type: 'number',
        },
      ],
    },
  ],
} as ModelType
